import {
    Box,
    Grid,
    Tab,
    Tabs,
    Typography,
} from "@mui/material";
import PopupTable from "./PopupTable";
import ProfileSection from "../ProfileSection";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const CAMPAIGN_TABS= Object.freeze({
    POPUP: "Popup Banner",
    PUSHNOTIFICATION: "Push Notifications",
})

const Campaign = () => {
    const navigate = useNavigate();    

    const userData = useSelector((state) => state.user.data.data);
    const [tabName, setTabName] = useState(CAMPAIGN_TABS.POPUP);

    useEffect(() => {
        if (!["superadmin", "countryadmin"].includes(userData?.facility_admin_type))
            navigate("/dashboard")
    }, [userData, navigate]);

    const tabContent = useMemo(() => {
        switch (tabName) {
            case CAMPAIGN_TABS.POPUP:
                return <PopupTable />;
            default:
                return <Box sx={{ padding: 2 }}>Reserved feature...</Box>;
        }
    }, [tabName]);

    function handleTabChange(_, newValue) {
        setTabName(newValue);
    };

    function renderTabs() {
        return (
            <Box sx={{ maxWidth: { xs: 320, sm: 700 }, bgcolor: "white", borderBottom: "1px solid #EAEBEE", zIndex:111 }} style={{maxWidth: "100%"}} >
                <Tabs value={tabName} onChange={ handleTabChange } variant="scrollable" scrollButtons={false}>
                    {Object.keys(CAMPAIGN_TABS).map((key) => (
                        <Tab label={CAMPAIGN_TABS[key]} value={CAMPAIGN_TABS[key]} key={key} />
                    ))}
                </Tabs>
            </Box>
        )
    };

    return (
        <Grid>
            <Grid container rowSpacing={3} columnSpacing={3} alignItems='center' style={{ backgroundColor: "white", marginBottom: "20px" }}>
                <Grid item xs={8} style={{ flexGrow: 1, padding: '0 20px', alignItems: 'center', display: "flex" }}>
                    <Typography variant="h4" fontSize='20px' fontWeight='600'>
                        Campaign
                    </Typography>
                </Grid>
                <Grid item xs={4} style={{ paddingTop: "5px" }}>
                    <ProfileSection />
                </Grid>
            </Grid>
            <Grid>
                <Grid style={{ background: "white", borderRadius: "16px" }}>
                    <Grid style={{ padding: "8px 16px 0 16px" }}>
                        { renderTabs() }
                    </Grid>
                    { tabContent }
                </Grid>
            </Grid>
        </Grid>
    );
}

export default Campaign;